import { SlotLabelContentArg } from '@fullcalendar/core';
import clsx from 'clsx';
import moment, { Moment } from 'moment-timezone';
import React from 'react';
import styles from './DayHeader.module.scss';

type BoardingDayHeaderProps = Omit<SlotLabelContentArg, 'date'> & {
    date: Moment;
    timeZone: string;
};

export const BoardingDayHeader: React.FC<BoardingDayHeaderProps> = ({ date, timeZone, ...props }) => {
    const today = moment().tz(timeZone);

    return (
        <div className={styles.root}>
            <p className={styles.dayName}>{date.format('ddd')}</p>
            <p
                className={clsx(styles.dayNumber, {
                    [styles.today]: date.isSame(today, 'day')
                })}
            >
                {date.format('DD')}
            </p>
        </div>
    );
};
